import { getDataFromResponse, getUnAuthenticatedAxios } from './helpers';

const BannersApiEndpoints = {
  getBanners: () => getUnAuthenticatedAxios()
    .get('banner')
    .then(getDataFromResponse),
};

export default BannersApiEndpoints;
